import * as Yup from "yup";

export default function AddClassesValidationSchema() {
  return Yup.object().shape({
    name: Yup.string().required('Required')
  });
}
